import { call, put, takeEvery, select } from "redux-saga/effects"
import MainInformationTypes from "Containers/MainInformations/types"

import {
  setSuccessMessage,
  setErrorMessage,
  removeErrorMessage,
  removeSuccessMessage,
} from "Containers/Messages/actions"

import {
  setCheckPasswordResultAction,
  setPasswordIsCheckedAction,
} from "Containers/MainInformations/actions"

import {
  responseTypeIsError,
  responseTypeIsSuccess,
  manageErrorGenerator,
  manageSuccessGenerator,
} from "Containers/App/saga"

//SELECTORS
import { selectCurrentToken } from "Containers/Login/selectors.js"

// Utils
import { postCors } from "Utils/rulesCors"
import { config } from "Utils/config"
import request from "Utils/request"

function* checkPassword({ payload }) {
  const token = yield select(selectCurrentToken)
  const { old_password } = payload

  try {
    const response = yield call(
      request,
      `${config.API_URL}/checkUserPassword`,
      postCors({ old_password }, { token })
    )

    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      yield put(setCheckPasswordResultAction(response.oldPasswordIsOk))
      yield put(setPasswordIsCheckedAction(true))
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      }
    }
  } catch (err) {
    console.error("[route] => /checkPassword => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

function* mainInformationsSaga() {
  yield takeEvery(MainInformationTypes.CHECK_PASSWORD, checkPassword)
}

export default mainInformationsSaga
